import { Chip } from '@material-ui/core';
import React from 'react';

interface Props {
  className?: string;
  label?: string;
  isSelected: boolean;
  width?: string;
  onClick: () => void;
}

export const SelectionChip = ({
  className,
  label = 'label',
  isSelected = false,
  width = 'auto',
  onClick
}: Props) => {
  return (
    <Chip
      className={className}
      label={label}
      color="primary"
      variant={isSelected ? undefined : 'outlined'}
      onClick={onClick}
      style={{ width: width }}
    />
  );
};
